import React from "react";

/**
 * Tier badge — matches the header plan-chip visual language exactly so the
 * badge in a Melting Point user card is the same font, size and icon as the
 * one next to the ImmoMap logo.
 *
 * Feb 2026 tier lineup:
 *   demo   — grey  hourglass · in prova
 *   bronze — brown clock     · accesso base (formerly "demo")
 *   silver — slate star      · intermedio (formerly "rookie")
 *   gold   — amber trophy    · top tier   (formerly "pro")
 */
const TIER_META = {
  demo:   { icon: "hourglass", color: "#8E8E93", label: "Demo"   },
  bronze: { icon: "clock",     color: "#A16207", label: "Bronze" },
  silver: { icon: "star",      color: "#64748B", label: "Silver" },
  gold:   { icon: "trophy",    color: "#F59E0B", label: "Gold"   },
  rookie: { icon: "star",   color: "#64748B", label: "Silver" },
  pro:    { icon: "trophy", color: "#F59E0B", label: "Gold"   },
};

const TierBadge = ({ tier = "demo", title, className = "", iconOnly = false, iconSize = 20 }) => {
  const meta = TIER_META[tier] || TIER_META.demo;
  // Icon-only mode: just the 3D emoji-style icon with a soft drop-shadow.
  // Used when overlaying on an avatar corner (Melting Point user cards etc.).
  if (iconOnly) {
    return (
      <img
        data-testid={`tier-badge-${tier}`}
        src={`/board-icons/${meta.icon}.png`}
        alt={meta.label}
        title={title || `Piano: ${meta.label}`}
        className={`object-contain select-none pointer-events-none ${className}`}
        style={{
          width: iconSize,
          height: iconSize,
          filter: `drop-shadow(0 1.5px 2px ${meta.color}80) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))`,
        }}
      />
    );
  }
  return (
    <span
      data-testid={`tier-badge-${tier}`}
      className={`inline-flex items-center gap-1 text-[9px] font-bold tracking-[0.18em] uppercase leading-none pl-1 pr-1.5 py-0.5 rounded-md shadow-sm ${className}`}
      style={{
        background: `${meta.color}18`,
        color: meta.color,
        border: `1px solid ${meta.color}55`,
      }}
      title={title || `Piano: ${meta.label}`}
    >
      <img
        src={`/board-icons/${meta.icon}.png`}
        alt=""
        aria-hidden="true"
        className="w-3.5 h-3.5 object-contain"
        style={{ filter: `drop-shadow(0 1px 1.5px ${meta.color}80)` }}
      />
      {meta.label}
    </span>
  );
};

export { TIER_META };
export default TierBadge;
